import { Routes } from '@angular/router';
import { authGuard } from '../../core/guards';

export const sponsorsRoutes: Routes = [
  {
    path: 'sponsors',
    loadComponent: () =>
      import('./components/sponsor-list/sponsor-list.component').then(
        (m) => m.SponsorListComponent
      ),
  },
  {
    path: 'sponsors/new',
    loadComponent: () =>
      import('./components/create/sponsor-create.component').then((m) => m.SponsorCreateComponent),
    canActivate: [authGuard],
  },
  {
    path: 'sponsors/:id/edit',
    loadComponent: () =>
      import('./components/edit/sponsor-edit.component').then((m) => m.SponsorEditComponent),
    canActivate: [authGuard],
  },
  {
    path: 'sponsors/:id',
    loadComponent: () =>
      import('./components/detail/sponsor-detail.component').then((m) => m.SponsorDetailComponent),
  },
  {
    path: 'sponsor-lines',
    loadComponent: () =>
      import('./components/sponsor-lines-list/sponsor-lines-list.component').then(
        (m) => m.SponsorLinesListComponent
      ),
  },
  {
    path: 'sponsor-lines/new',
    loadComponent: () =>
      import('./components/sponsor-line-create/sponsor-line-create.component').then(
        (m) => m.SponsorLineCreateComponent
      ),
    canActivate: [authGuard],
  },
  {
    path: 'sponsor-lines/:id/edit',
    loadComponent: () =>
      import('./components/sponsor-line-edit/sponsor-line-edit.component').then(
        (m) => m.SponsorLineEditComponent
      ),
    canActivate: [authGuard],
  },
  {
    path: 'sponsor-lines/:id',
    loadComponent: () =>
      import('./components/sponsor-line-detail/sponsor-line-detail.component').then(
        (m) => m.SponsorLineDetailComponent
      ),
  },
];
